import React from 'react';
import { images } from '../shared/assets';
import { ContentfulImage } from '../Contentful';
import './InteriorGallery.css';

interface InteriorGalleryProps {
  property?: string;
}

const InteriorGallery: React.FC<InteriorGalleryProps> = ({ property = "patagonia" }) => {
  // Get property-specific content
  const getContentForProperty = () => {
    switch (property.toLowerCase()) {
      case 'patagonia':
      default:
        return {
          title: "Only 14 stand-alone Villas with a direct view of Torres del Paine.",
          description: "Awasi Patagonia is located in a private reserve with impressive views of the Torres del Paine mountain range and Lake Sarmiento. A dense native forest of lenga and ñirre trees shelters the lodge from the region's strong Patagonian winds. The native fauna thrives undisturbed, with frequent sightings of guanacos, ñandus, foxes, condors, and if you are lucky, pumas.",
          locationText: "Patagonia",
          countryText: "CHILE"
        };
      case 'atacama':
        return {
          title: "A real-life oasis, steeped in history",
          description: "At over 2,500 metres above sea level, step into this otherworldly place and feel as if you are on another planet. It's called the Atacama Desert, but there is so much more than just desert. Enjoy breathtaking landscapes by day and world-class stargazing by night.",
          locationText: "Atacama",
          countryText: "CHILE"
        };
      case 'iguazu':
        return {
          title: "Nestled in the jungle",
          description: "Stepping away from the layout of a classic hotel, we have created 14 private Villas nestled in the Atlantic Rainforest jungle.",
          locationText: "Iguazú",
          countryText: "ARGENTINA"
        };
      case 'mendoza':
        return {
          title: "Nestled in a 55 acre vineyard",
          description: "17 private Villas stand in a vineyard at the foothills of the Andes Mountains, immersed in the heart of wine country's local culture.",
          locationText: "Mendoza",
          countryText: "ARGENTINA"
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          title: "Nestled on a lush peninsula at Emerald Coast",
          description: "With 25 ocean-view Villas, a private island and special care, perfect to relax and enjoy yourself.",
          locationText: "Santa Catarina",
          countryText: "BRAZIL"
        };
    }
  };

  const content = getContentForProperty();
  return (
    <div className="interior-gallery">
      <div className="gallery-left">
        <div className="map-container">
          <div className="map-overlay">
            <img src={images.mapOverlay} alt="Map" />
          </div>
          <div className="location-badge">
            <span className="location-text">{content.locationText}</span>
            <img src={images.mapLine} alt="" className="location-line" />
            <span className="country-text">{content.countryText}</span>
          </div>
        </div>
        <h2 className="gallery-left__title">{content.title}</h2>
        <p>{content.description}</p>
      </div>
      <div className="gallery-right">
        <ContentfulImage imageKey="gallery-main" fallbackSrc={images.galleryMain} alt="Mountain landscape" className="gallery-main" />
        <img src={images.galleryVilla} alt="Villa exterior" className="gallery-top-right" />
        <ContentfulImage imageKey="gallery-wildlife" fallbackSrc={images.galleryWildlife} alt="Puma wildlife" className="gallery-bottom-right" />
      </div>
    </div>
  );
};

export default InteriorGallery; 